import { Autocomplete, TextField, Typography } from '@mui/material';
import * as React from 'react';
import { useState } from 'react';

type AutoCompleteVelocidadesProps = {
    onChange: (velocidad: string) => void,
    value: string,
    label?: string
};

export default function AutoCompleteVelocidades({ onChange, value, label = "Seleccionar velocidad" }: AutoCompleteVelocidadesProps) {
    const [open, setOpen] = useState(false);
    const [velocidadesList] = useState([
        { nombre: 'Plazo único', valor: '-1' },
        { nombre: 'Simple', valor: '1' },
        { nombre: 'Urgente', valor: '2' },
        { nombre: 'Express', valor: '3' },
        { nombre: 'En el día', valor: '4' },
        { nombre: 'Certificada', valor: '5' },
        { nombre: 'Capital', valor: '6' },
        { nombre: 'Provincia', valor: '7' },
    ]);

    return (
        <>
            <Autocomplete
                fullWidth
                value={velocidadesList.find((velocidad) => velocidad.valor === value) || null}
                open={open}
                onOpen={() => {
                    setOpen(true);
                }}
                onClose={() => {
                    setOpen(false);
                }}
                isOptionEqualToValue={(option, value) => option.valor === value.valor}
                getOptionLabel={(option) => option.nombre}
                options={velocidadesList}
                onChange={(event, newValue) => {
                    onChange(newValue ? newValue.valor : '');
                }}
                loadingText="Cargando..."
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                    />
                )}
                renderOption={(props, option, { selected }) => (
                    <li {...props}>
                        <Typography noWrap>
                            {option.nombre}
                        </Typography>
                    </li>
                )}
            />
        </>
    );
}